export default "__VITE_ASSET__C6wxgHM1__"